import React, { Component } from "react";
import axios from "axios";
// import $ from 'jquery';

import './Header.scss';
import MyContext from '../MyContext.jsx';
import Select, { components } from "react-select";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <i
        className="fas fa-chevron-down"
        style={{
          color: '#ffffff',
          fontSize: '11px',
          fontWeight: '900',
          transition: 'transform 0.25s ease',
          transform: props.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          display: 'inline-block'
        }}
      />
    </components.DropdownIndicator>
  );
};

const divisionSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '26px',
    height: '26px',
    backgroundColor: 'rgba(255, 255, 255, 0.16)',
    border: '1px solid rgba(255, 255, 255, 0.35)',
    borderRadius: '13px',
    boxShadow: 'none',
    cursor: 'pointer',
    padding: '0 8px 0 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.24)',
      borderColor: 'rgba(255, 255, 255, 0.5)'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    minWidth: 0
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#ffffff',
    fontWeight: '600',
    fontSize: '11px',
    letterSpacing: '0.3px',
    margin: 0,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'rgba(255, 255, 255, 0.75)',
    fontSize: '11px',
    margin: 0
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center'
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0 0 0 5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  menuPortal: (provided) => ({
    ...provided,
    zIndex: 9999
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    width: 'max-content',
    minWidth: '150px',
    maxWidth: '240px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
    backgroundColor: '#ffffff',
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
    marginTop: '4px'
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '12px',
    fontWeight: state.isSelected ? '600' : '400',
    padding: '8px 12px',
    color: state.isSelected ? '#ffffff' : '#333333',
    backgroundColor: state.isSelected ? '#420b3e' : state.isFocused ? '#f5eef4' : '#ffffff',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: '#420b3e',
      color: '#ffffff'
    }
  })
};


class Header extends Component {
  constructor(props) {
    super(props);
    // this.props.history.replace('/');
    this.state = {
    }
    this.divisionChange = this.divisionChange.bind(this);

  }

  componentDidMount(){ 
    var obj_this = this;
    $("#root").on("click",".logout_button", function(){
      if(!confirm("Are you sure you want to logout?")){
        return;
      }
      // obj_this.context.loading(1);
      var user_details = window.localStorage.getItem("user_details_pharmacopius_emak_app");
      console.log(user_details);
      const url = `${process.env.REACT_APP_SSS}/api/logout`;
      $.ajax({
        url : url,
        data : {
          user_details : user_details,
          sid : obj_this.context.user_details.sid
        },
        type : "POST"
      }).done(function(return_data){
        console.log(return_data);
        if(return_data.status == "success"){
          alert("Logged out successfully");
          obj_this.context.setUserDetails({});
          user_details = JSON.parse(user_details);
          let new_user= {
            "username":user_details.username,
            "password" : user_details.password
          };
          window.localStorage.setItem("user_details_pharmacopius_emak_app",JSON.stringify(new_user));
          obj_this.props.history.replace('/');
        }else{
          alert("Network error!!");
          obj_this.props.history.replace('/');
        }
        // obj_this.context.loading(0);
      }).fail(function(){
          alert("Network error!!");
          obj_this.props.history.replace('/');
      });
    });
    // cordova.plugins.locationAccuracy.request(function(){console.log("location success")}, function(){"location error"});
  }
  divisionChange(option){
    if(option.value == this.context.user_details.division.value){
      return;
    }
    if(!confirm("Are you sure, Change division to "+option.label+" ?")){
      return;
    }
    var obj_this = this;
    obj_this.context.loading(1);
    $.ajax({
      url : process.env.REACT_APP_SSS + "/api/changeDivision",
      data : {
        division: option,
        sid : obj_this.context.user_details.sid,
        username : obj_this.context.user_details.username,
        password : obj_this.context.user_details.password,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        delete return_data.status;
        return_data.division = option;
        obj_this.context.setUserDetails(return_data);
        window.localStorage.setItem("user_details_pharmacopius_emak_app",JSON.stringify(return_data));
        obj_this.props.history.replace('/dashboard');
        obj_this.props.history.replace('/home');
      }else{
        alert("You are not authorized to access");
      }
      obj_this.context.loading(0);
    }).fail(function(){
      alert("Network error");
    });
  }


  render(){
  const {pathname} = this.props.location;
  if(pathname === "/android_asset/www/index.html" || pathname === "/") {
    return null;
  }
  return (
    <MyContext.Consumer>
      {context => (
        <div className="header_container">
          <div className="app_name">E-MAK Pro</div>
          <div className="name_division_container">
            <div className="username">Hello, {this.context.user_details?.fullname || ''}</div>
            <div className="division">
              <Select
                className="division_select"
                classNamePrefix="division_select"
                options={this.context.user_details?.divisions || []}
                value={this.context.user_details?.division}
                onChange={this.divisionChange}
                isSearchable={false}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                styles={divisionSelectStyles}
                components={{
                  DropdownIndicator,
                  IndicatorSeparator: () => null
                }}
              />
            </div>
          </div>
          <div className="logout_button">
            <i className="fa fa-sign-out-alt" style={{padding:"10px"}}></i>
          </div>
        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Header;
Header.contextType = MyContext;

